"use client";

import { c as _c } from "react/compiler-runtime";
import { useFeatureValue } from "@growthbook/growthbook-react";
import GoogleSignInScriptBase from "./GoogleSignInScriptBase";

/**
 * GoogleSignInScriptPagesRouter for Pages Router (client-side feature flag check)
 * Uses GrowthBookProvider context to check feature flag
 * Used in: src/hocs/page.tsx
 */
export default function GoogleSignInScriptPagesRouter() {
  const $ = _c(3);
  const isEnabled = useFeatureValue("google_sso", true);
  const isPiwikTrackingEnabled = useFeatureValue("piwik_tracking", true);
  const shouldDeferScriptUntilPiwikConsent = isPiwikTrackingEnabled && process.env.NEXT_PUBLIC_API_MOCKING !== "enabled";
  let t0;
  if ($[0] !== isEnabled || $[1] !== shouldDeferScriptUntilPiwikConsent) {
    t0 = <GoogleSignInScriptBase enabled={isEnabled} deferScriptUntilPiwikConsent={shouldDeferScriptUntilPiwikConsent} />;
    $[0] = isEnabled;
    $[1] = shouldDeferScriptUntilPiwikConsent;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}